function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { createTheme } from "@mui/material/styles";
import { makeAccordionStyles } from "./theme-base/accordion";
import { makeAlertStyles } from "./theme-base/alert";
import { makeAutocompleteStyles } from "./theme-base/autocomplete";
import { makeBadgeStyles } from "./theme-base/badge";
import { makeBreadcrumbsStyles } from "./theme-base/breadcrumbs";
import { makeButtonGroupStyles } from "./theme-base/button-group";
import { makeButtonStyles } from "./theme-base/button";
import { makeCardStyles } from "./theme-base/card";
import { makeCheckboxStyles } from "./theme-base/checkbox";
import { makeChipStyles } from "./theme-base/chip";
import { makeCircularProgressStyles } from "./theme-base/circular-progress";
import { makeContainerStyles } from "./theme-base/container";
import { makeDatePickerStyles } from "./theme-base/date-picker";
import { makeDialogStyles } from "./theme-base/dialog";
import { makeDividerStyles } from "./theme-base/divider";
import { makeFilledInputStyles } from "./theme-base/filled-input";
import { makeFormControlLabelStyles } from "./theme-base/form-control-label";
import { makeFormControlStyles } from "./theme-base/form-control";
import { makeFormGroupStyles } from "./theme-base/form-group";
import { makeFormHelperTextStyles } from "./theme-base/form-helper-text";
import { makeFormLabelStyles } from "./theme-base/form-label";
import { makeGridStyles } from "./theme-base/grid";
import { makeGrid2Styles } from "./theme-base/grid-2";
import { makeIconButtonStyles } from "./theme-base/icon-button";
import { makeInputLabelStyles } from "./theme-base/input-label";
import { makeInputStyles } from "./theme-base/input";
import { makeLinearProgressStyles } from "./theme-base/linear-progress";
import { makeLinkStyles } from "./theme-base/link";
import { makeListSubheaderStyles } from "./theme-base/list-subheader";
import { makeMenuItemStyles } from "./theme-base/menu-item";
import { makeOutlinedInputStyles } from "./theme-base/outlined-input";
import { makePaginationStyles } from "./theme-base/pagination";
import { makePopoverStyles } from "./theme-base/popover";
import { makePopperStyles } from "./theme-base/popper";
import { makeRadioStyles } from "./theme-base/radio";
import { makeSelectStyles } from "./theme-base/select";
import { makeSkeletonStyles } from "./theme-base/skeleton";
import { makeSnackbarStyles } from "./theme-base/snackbar";
import { makeStepperStyles } from "./theme-base/stepper";
import { makeSvgIconStyles } from "./theme-base/svg-icon";
import { makeTableStyles } from "./theme-base/table";
import { makeTabsStyles } from "./theme-base/tabs";
import { makeTextFieldStyles } from "./theme-base/text-field";
import { makeToggleButtonGroupStyles } from "./theme-base/toggle-button-group";
import { makeToggleButtonStyles } from "./theme-base/toggle-button";
import { makeToolbarStyles } from "./theme-base/toolbar";
import { makeTooltipStyles } from "./theme-base/tooltip";
import { makeTreeItemStyles } from "./theme-base/tree-item";
import { makeTreeViewStyles } from "./theme-base/tree-view";
import { makeTypographyStyles } from "./theme-base/typography";
/**
 * Returns a MUI-compatible theme base object
 *
 * @param {Object} props
 * @param {paletteMode} [props.paletteMode=light] - Light or dark
 * @param {Object} props.themeData - Digital HIG design tokens
 *
 * @returns {Object} Returns a MUI theme.
 */
export var getThemeBase = function getThemeBase(_ref) {
  var _ref$paletteMode = _ref.paletteMode,
    paletteMode = _ref$paletteMode === void 0 ? "light" : _ref$paletteMode,
    _ref$themeData = _ref.themeData,
    primitives = _ref$themeData.primitives,
    tokens = _ref$themeData.tokens;
  /* TODO: [Typescript] Migrate the htmlFontSize logic to work with createTheme */
  // Modify rem-based primitive and token values for cases in which the
  // root font size of the page is not set to the default 16px
  // const htmlFontSize = additionalThemeOptions?.typography?.htmlFontSize ?? 16;

  // const htmlFontSizeRatio = htmlFontSize / 16;

  // const primitives = {
  //   ...themeData.primitives,
  //   fontSizes: Object.entries(themeData.primitives.fontSizes).reduce(
  //     (acc, [key, fontSize]) => {
  //       acc[key] =
  //         htmlFontSizeRatio === 1
  //           ? fontSize
  //           : `calc(${fontSize} / ${htmlFontSizeRatio})`;
  //       return acc;
  //     },
  //     {}
  //   )
  // };

  // const typographyTokens = Object.entries(themeData.tokens.typography).reduce(
  //   (acc, [key, token]) => {
  //     acc[key] = {
  //       ...token,
  //       fontSize:
  //         htmlFontSizeRatio === 1
  //           ? token.fontSize
  //           : `calc(${token.fontSize} / ${htmlFontSizeRatio})`
  //     };
  //     return acc;
  //   },
  //   {}
  // );

  // const tokens = {
  //   ...themeData.tokens,
  //   typography: typographyTokens
  // };

  // Create a MUI-compatible breakpoint configuration based on theme data
  var breakpointValues = Object.entries(tokens.grid).reduce(function (acc, _ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      key = _ref3[0],
      value = _ref3[1];
    acc.keys.push(key);
    acc.values[key] = parseInt(value.breakpoint, 10);
    return acc;
  }, {
    keys: [],
    values: {}
  });
  var _createTheme = createTheme({
      breakpoints: breakpointValues
    }),
    breakpoints = _createTheme.breakpoints;
  var transitionValues = Object.entries(tokens.transitions).reduce(function (acc, _ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
      key = _ref5[0],
      value = _ref5[1];
    acc.duration[key] = value.transitionDuration;
    acc.easing[key] = value.transitionTimingFunction;
    return acc;
  }, {
    duration: {},
    easing: {}
  });

  /* istanbul ignore next */
  return {
    breakpoints: breakpoints,
    direction: "ltr",
    palette: {
      mode: paletteMode,
      common: {
        black: primitives.colors.primary.black,
        white: primitives.colors.primary.white
      },
      primary: {
        main: paletteMode === "light" ? primitives.colors.primary.black : primitives.colors.primary.white
      },
      error: {
        main: tokens.colors["ink-error"]
      },
      success: {
        main: tokens.colors["fill-success"]
      },
      urgency: {
        main: tokens.colors["fill-urgent"]
      },
      attention: {
        main: tokens.colors["fill-warning"]
      },
      neutral: {
        main: tokens.colors["detail-1-opaque"]
      },
      text: {
        primary: primitives.colors.primary.black,
        secondary: primitives.colors.primary.white
      },
      divider: "rgba(0, 0, 0, 0.1)",
      background: {
        paper: tokens.colors.background,
        // Background for Card, Tabs
        default: tokens.colors.background
      }
    },
    typography: _objectSpread({
      fontFamily: primitives.fontFamilies.default,
      fontWeightLight: primitives.fontWeights.default,
      fontWeightRegular: primitives.fontWeights.default,
      fontWeightMedium: primitives.fontWeights.emphasized,
      fontWeightBold: primitives.fontWeights.display,
      body1: tokens.typography["body-copy-medium"]
    }, tokens.typography),
    spacing: Object.entries(primitives.spacings).map(function (_ref6) {
      var _ref7 = _slicedToArray(_ref6, 2),
        _ = _ref7[0],
        value = _ref7[1];
      return value;
    }),
    transitions: _objectSpread({}, transitionValues),
    zIndex: {},
    primitives: primitives,
    tokens: tokens,
    components: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, makeAccordionStyles({
      primitives: primitives,
      tokens: tokens
    })), makeAlertStyles({
      primitives: primitives,
      tokens: tokens
    })), makeAutocompleteStyles({
      primitives: primitives,
      tokens: tokens
    })), makeBadgeStyles({
      primitives: primitives,
      tokens: tokens
    })), makeBreadcrumbsStyles({
      primitives: primitives,
      tokens: tokens
    })), makeButtonGroupStyles({
      primitives: primitives,
      tokens: tokens
    })), makeButtonStyles({
      primitives: primitives,
      tokens: tokens
    })), makeCardStyles({
      primitives: primitives,
      tokens: tokens
    })), makeCheckboxStyles({
      primitives: primitives,
      tokens: tokens
    })), makeChipStyles({
      primitives: primitives,
      tokens: tokens
    })), makeCircularProgressStyles({
      primitives: primitives,
      tokens: tokens
    })), makeContainerStyles({
      breakpoints: breakpoints,
      primitives: primitives
    })), makeDatePickerStyles({
      primitives: primitives,
      tokens: tokens
    })), makeDialogStyles({
      breakpoints: breakpoints,
      paletteMode: paletteMode,
      primitives: primitives,
      tokens: tokens
    })), makeDividerStyles({
      tokens: tokens
    })), makeFilledInputStyles({
      primitives: primitives,
      tokens: tokens
    })), makeFormControlLabelStyles({
      primitives: primitives,
      tokens: tokens
    })), makeFormControlStyles({
      primitives: primitives,
      tokens: tokens
    })), makeFormGroupStyles({
      primitives: primitives
    })), makeFormHelperTextStyles({
      primitives: primitives,
      tokens: tokens
    })), makeFormLabelStyles({
      tokens: tokens
    })), makeGridStyles({
      breakpoints: breakpoints,
      primitives: primitives,
      tokens: tokens
    })), makeGrid2Styles({
      tokens: tokens
    })), makeIconButtonStyles({
      primitives: primitives,
      tokens: tokens
    })), makeInputLabelStyles({
      primitives: primitives,
      tokens: tokens
    })), makeInputStyles({
      primitives: primitives,
      tokens: tokens
    })), makeLinearProgressStyles({
      primitives: primitives,
      tokens: tokens
    })), makeLinkStyles({
      tokens: tokens
    })), makeListSubheaderStyles({
      primitives: primitives,
      tokens: tokens
    })), makeMenuItemStyles({
      primitives: primitives,
      tokens: tokens
    })), makeOutlinedInputStyles({
      primitives: primitives,
      tokens: tokens
    })), makePaginationStyles({
      primitives: primitives,
      tokens: tokens
    })), makePopoverStyles({
      primitives: primitives,
      tokens: tokens
    })), makePopperStyles({
      primitives: primitives,
      tokens: tokens
    })), makeRadioStyles({
      primitives: primitives,
      tokens: tokens
    })), makeSelectStyles({
      primitives: primitives,
      tokens: tokens
    })), makeSkeletonStyles({
      tokens: tokens
    })), makeSnackbarStyles({
      primitives: primitives,
      tokens: tokens
    })), makeStepperStyles({
      primitives: primitives,
      tokens: tokens
    })), makeSvgIconStyles({
      primitives: primitives,
      tokens: tokens
    })), makeTableStyles({
      primitives: primitives,
      tokens: tokens
    })), makeTabsStyles({
      primitives: primitives,
      tokens: tokens
    })), makeTextFieldStyles({
      primitives: primitives,
      tokens: tokens
    })), makeToggleButtonGroupStyles({
      primitives: primitives,
      tokens: tokens
    })), makeToggleButtonStyles({
      primitives: primitives,
      tokens: tokens
    })), makeToolbarStyles({
      primitives: primitives,
      tokens: tokens
    })), makeTooltipStyles({
      primitives: primitives,
      tokens: tokens
    })), makeTreeItemStyles({
      primitives: primitives,
      tokens: tokens
    })), makeTreeViewStyles({
      primitives: primitives,
      tokens: tokens
    })), makeTypographyStyles({
      tokens: tokens
    }))
  };
};